import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCapIcon, AwardIcon } from 'lucide-react';
import { education, certifications } from '../data/profile';
import { SectionHeading } from './SectionHeading';
type CredentialCardProps = {
  title: string;
  icon: React.ElementType;
  items: {
    degree: string;
    institution: string;
  }[];
  delay: number;
};
function CredentialCard({
  title,
  icon: Icon,
  items,
  delay
}: CredentialCardProps) {
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.3
  }} transition={{
    duration: 0.5,
    delay
  }} className="border border-navy/10 bg-white shadow-card" data-id="element-72" data-mp="2bnibwfljowi6">
      <header className="flex items-center gap-4 border-b border-navy/10 bg-canvas px-7 py-6" data-id="element-73" data-mp="2gm1z0jbvkec4">
        <span className="flex h-11 w-11 items-center justify-center border border-gold/40 bg-navy" data-id="element-74" data-mp="ue4svo8wzx0">
          <Icon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-75" data-mp="3s29uy1wswret" />
        </span>
        <h3 className="font-display text-base font-bold uppercase tracking-[0.14em] text-navy" data-id="element-76" data-mp="3eeqw8wi805rl">
          {title}
        </h3>
      </header>
      <ul className="divide-y divide-navy/5 px-7" data-id="element-77" data-mp="3jca8jqvcy8gw">
        {items.map(item => <li key={item.degree} className="py-6" data-id="element-78" data-mp="3odpvxpl0cr2g">
            <p className="font-display text-base font-bold leading-snug text-navy" data-id="element-79" data-mp="3oatzy6sq0cgn">
              {item.degree}
            </p>
            <p className="mt-1.5 text-sm font-medium text-navy-steel/80" data-id="element-80" data-mp="2voiyyv17c9jb">
              {item.institution}
            </p>
          </li>)}
      </ul>
    </motion.article>;
}
export function Credentials() {
  return <section id="credentials" className="w-full scroll-mt-20 border-t border-navy/10 bg-ocean-mist py-20 lg:py-28" aria-labelledby="credentials-heading" data-id="element-81" data-mp="35lexq91athao">
      <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-82" data-mp="2cyb0wrcd099z">
        <SectionHeading id="credentials-heading" eyebrow="Section 04 · Education & Credentials" title="Academic Foundation & Certification" data-id="element-83" data-mp="2cvos6odqfnq6" />

        <div className="mt-14 grid grid-cols-1 gap-8 lg:grid-cols-2" data-id="element-84" data-mp="29u3m9jv73jrh">
          <CredentialCard title="Formal Education" icon={GraduationCapIcon} items={education} delay={0} data-id="element-85" data-mp="24vs6ytm4sh1v" />
          <CredentialCard title="Certifications & Training" icon={AwardIcon} items={certifications} delay={0.1} data-id="element-86" data-mp="2emwpu4exgm1z" />
        </div>
      </div>
    </section>;
}